import { render, staticRenderFns } from "./brand-manager.vue?vue&type=template&id=401bf1ed"
import script from "./brand-manager.vue?vue&type=script&lang=js"
export * from "./brand-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports